import { CollectionChainType } from '@app/client/common/structs/daas/v2/common/chains';

interface NftDetailsUrlType {
    contractAddress: string;
    tokenId: string;
    chain?: CollectionChainType;
    goBackEnabled?: boolean;
}

export function getCollectionEthUrl(slug = '', chain?: CollectionChainType) {
    // TODO: This address needs to allow `eth` segment to be customized.
    return slug.length ? `/collection/${chain}/${slug}` : undefined;
}

export function getNftDetailsUrl({
    contractAddress,
    tokenId,
    chain = CollectionChainType.Ethereum,
    goBackEnabled = false,
}: NftDetailsUrlType) {
    let suffix = '';
    const search = {};

    if (goBackEnabled) {
        search['goBack'] = '1';
    }

    if (Object.keys(search).length) {
        suffix = `?${new URLSearchParams(search).toString()}`;
    }

    return `/collectible/${chain.toLowerCase()}/${contractAddress}/${tokenId}${suffix}`;
}
